module.exports = __webpack_public_path__ + "static/media/DC-logo-mini.3717c01a.png";